var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order" },
    [
      _c("div", { staticClass: "ex-tab-list" }, [
        _c(
          "div",
          {
            staticClass: "ex-tab active-side __pointer",
            class: { active: _vm.tab === "openOrder" },
            on: {
              click: function($event) {
                return _vm.switchTab("openOrder")
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("tradeOpenOrders.title")))])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ex-tab active-side __pointer",
            class: { active: _vm.tab === "historyOrder" },
            on: {
              click: function($event) {
                return _vm.switchTab("historyOrder")
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("tradeOrderHistory.title")))])]
        )
      ]),
      _vm._v(" "),
      _c("openOrder", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tab === "openOrder",
            expression: "tab==='openOrder'"
          }
        ],
        staticClass: "item order-tab"
      }),
      _vm._v(" "),
      _c("historyOrder", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tab === "historyOrder",
            expression: "tab==='historyOrder'"
          }
        ],
        staticClass: "item order-tab"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }